import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id E79B26A6-CAA3-4CD8-B5C8-1D5797C4C765
 * name format-text-variant
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-text-variant.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatTextVariantIcon = createSvgIcon(<><path d="M9.6,14L12,7.7L14.4,14M11,5L5.5,19H7.7L8.8,16H15L16.1,19H18.3L13,5H11Z" /></>, 'FormatTextVariantIcon');
export default FormatTextVariantIcon